import './vessel-loader';
import { VesselLoader } from '../src/vessel-loader';

interface CreateLoaderOptions
{
    headerText: string;
    showCancelButton?: boolean;
    onCancel?: () => void;
}

export const VesselLoaderManager = new class {
    private loaderElement: VesselLoader | null = null;
    private cancelCallback?: () => void;

    createLoader(options: CreateLoaderOptions) {
        // Check if a loader already exists to avoid creating multiple instances
        if (!this.loaderElement) {
            this.loaderElement = document.createElement('vessel-loader') as VesselLoader;
            this.loaderElement.open = true;
            this.loaderElement.headerText = options.headerText || '';
            if(options.showCancelButton)
                this.loaderElement.showCancelButton = options.showCancelButton;
            this.cancelCallback = options.onCancel; // Save the custom callback

            this.loaderElement.addEventListener('cancel-loader', () => {
                this.cancelCallback?.(); // Call the custom cancel handler if present
                this.removeLoader();
            });
            document.body.appendChild(this.loaderElement);
        }
    }

    removeLoader() {
        if (this.loaderElement) {
            this.loaderElement.open = false;
            this.loaderElement.headerText = '';
            this.loaderElement.remove();
            this.loaderElement = null;
            this.cancelCallback = undefined;
        }
    }

    loaderIsActive(): boolean {
        return this.loaderElement !== null;
    }
};
